export default __webpack_public_path__ + "static/media/musisi_datang.e6be54fa.svg";